// extracted by mini-css-extract-plugin
export var active = "_kf-2";
export var recordingDot = "_kf-1";
export var recordingIndicator = "_kf-0";